import React from 'react'
import { Redirect } from 'react-router-dom'
import { ROUTE_DASHBOARD, ROUTE_DASH_STOCK_OPNAME } from 'fixtures/routes'

import List from './List'
import Form from './Form'
import ViewUpload from './ViewUpload'

const routes = [
  {
    path: '/',
    exact: true,
    main: () => (
      <Redirect to={`/${ROUTE_DASHBOARD}/${ROUTE_DASH_STOCK_OPNAME}`} />
    ),
    isProtected: true,
  },
  {
    path: `/`,
    exact: true,
    main: () => <List />,
    isProtected: true,
  },
  {
    path: `/add`,
    exact: true,
    main: () => <Form />,
    isProtected: true,
  },
  {
    path: `/edit/:id`,
    exact: true,
    main: () => <Form />,
    isProtected: true,
  },
  {
    path: `/view-upload`,
    exact: true,
    main: () => <ViewUpload />,
    isProtected: true,
  },
]

export default routes
